import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/header';
import Footer from '../components/footer';
import { api } from '../api/api';
import { toast } from 'react-toastify';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const RedeemClaimPage = () => {
  const location = useLocation();
  const [rewardDetails, setRewardDetails] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const rewardCode = queryParams.get('rewardId');

    if (rewardCode) {
      const fetchRewardDetails = async () => {
        try {
          // Assuming an API endpoint to fetch reward details by code
          const response = await api.get(`/api/giveaways/reward-details/${rewardCode}`);
          setRewardDetails(response.data);
        } catch (error) {
          console.error('Error fetching reward details:', error);
          toast.error('Failed to load reward details.');
        } finally {
          setLoading(false);
        }
      };
      fetchRewardDetails();
    } else {
      toast.error('No reward code found.');
      setLoading(false);
    }
  }, [location]);

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center text-white">
        <p>Loading reward details...</p>
      </div>
    );
  }

  if (!rewardDetails) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center text-white">
        <p>Reward details not found.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-900 text-white">
      <Header />
      <main className="flex-grow container mx-auto p-4">
        <h1 className="text-4xl font-bold text-center mb-8">Your Claimed Reward</h1>
        <div className="bg-gray-800 p-6 rounded-lg shadow-lg max-w-md mx-auto">
          <h2 className="text-2xl font-semibold mb-4">{rewardDetails.name}</h2>
          {rewardDetails.image_path && (
            <img src={`${API_URL}/uploads/${rewardDetails.image_path}`} alt={rewardDetails.name} className="w-full h-48 object-cover rounded-md mb-4" />
          )}
          <p className="text-gray-300 mb-2">{rewardDetails.description}</p>
          <p className="text-lg font-bold text-green-400">Price: ${rewardDetails.price}</p>
          <p className="text-sm text-gray-400">Category: {rewardDetails.category}</p>
          <p className="text-sm text-gray-400">Reward ID: {rewardDetails.reward_id}</p>
        </div>
      </main>
      <Footer type="sm" />
    </div>
  );
};

export default RedeemClaimPage;